import React from 'react';
import { Router, Route } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import Container from './components/Container';
import HomeScreen from './screens/HomeScreen';
import NoteScreen from './screens/NoteScreen';
import MethodologyScreen from './screens/MethodologyScreen';
import Header from './components/Header';
import Footer from './components/Footer';
// import ReactGA from 'react-ga';

const App = () => {
  const history = createBrowserHistory();

  // history.listen((location) => {
  //   ReactGA.set({ page: location.pathname });
  //   ReactGA.pageview(location.pathname);
  // });

  // useEffect(() => {
  //   ReactGA.pageview(window.location.pathname + window.location.search);
  // }, [history]);

  return (
    <Router history={history}>
      <main style={{ backgroundColor: '#2e1a4e' }}>
        <Container>
          <Header />
          <Route path="/" component={HomeScreen} exact />
          {/* <Route path="/feedback" render={() => history.push('/blog')} /> */}
          <Route path="/note" component={NoteScreen} />
          <Route path="/methodology" component={MethodologyScreen} />
          {/* <Route path="/API" render={() => history.push('/blog')} /> */}
          <Footer />
        </Container>
      </main>
    </Router>
  );
};

export default App;
